import React from 'react'
import { Drawer, Select, Mentions, Button, Tag, Tooltip } from 'antd'
import style from './style.module.scss'
import { withRouter } from 'react-router'
import SignalCasesService from 'services/signal_cases'
import Common from 'services/common'

const { Option } = Select
class NotesComp extends React.Component {
  constructor(props) {
    super(props)
    this.messagesEndRef = React.createRef()
    this.inputField = React.createRef()
    this.stopNotesList = null
    this.state = {
      SSID: localStorage.getItem('SSID'),
      scopeId: this.props.urlData['scopeId'],
      clusterId: this.props.urlData['clusterId'],
      casesList: [],
      filteredCasesList: [],
      inputValue: '',
      selectedCase: {},
      NoteMsg: '',
      NotesList: [],
      UsersList: [],
      tagList: [],
      UserDetails: Common.getUserPayload(),
      messageStatus: 'Save',
      openScrollToBottom: true,
    }
  }

  componentDidMount() {
    this.getAlloverUsersList()
    this.getAllCasesData()
    if (typeof this.props.CaseData !== 'undefined') {
      this.setState({ selectedCase: this.props.CaseData }, () => {
        this.getNotesList(this.props.CaseData, true)
      })
    }
    this.stopNotesList = setInterval(() => {
      if (Object.keys(this.state.selectedCase).length > 0 && this.state.NotesList.length > 0) {
        this.getNotesList(this.state.selectedCase, false)
      }
    }, 2000)
  }

  componentWillUnmount() {
    clearInterval(this.stopNotesList)
  }

  scrollToBottom = () => {
    const { NotesList } = this.state
    if (this.messagesEnd !== null && document.getElementById(NotesList[NotesList.length - 1].notes))
      this.messagesEnd.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  getAllCasesData = pageSize => {
    var param = {
      scope_id: this.state.scopeId,
      pageno: 1,
      pagesize: pageSize ? pageSize : 200,
      addfilters: [
        {
          filter_condition: 'AND',
          filter_key: 'status',
          filter_operand: 'IN',
          filter_value: ['OPEN', 'ON-HOLD', 'IN-PROGRESS'],
        },
      ],
    }
    SignalCasesService.getallCaseslist(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
          Common.showNotifications('error', 'Something went wrong')
        }
        if (response.data.status === 'success') {
          let cases = response.data.data
          if (this.props.CaseData !== undefined && this.props.CaseData.status === 'CLOSED') {
            cases.push(this.props.CaseData)
          }
          this.setState({ casesList: cases, filteredCasesList: cases })
          if (param.pagesize !== response.data.count && response.data.count > param.pagesize) {
            this.getAllCasesData(response.data.count)
          }
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        Common.showNotifications(
          'error',
          err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong',
        )
      })
  }

  setCaseData = data => {
    this.setState({ selectedCase: data })
    this.getNotesList(data, true)
  }

  getNotesList = (selected, scroll) => {
    var param = {
      case_id: [selected.case_id],
      scope_id: this.state.scopeId,
    }

    SignalCasesService.listNotes(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
          Common.showNotifications('error', 'Something went wrong')
        }
        if (response.data.status === 'success') {
          let JSONData = response.data.data[0][selected.case_id]
          let notes = []
          let ind = -1

          for (let i = 0; i < JSONData.length; i++) {
            let caseEntry = JSONData[i]

            // Check for the specific case condition and update the index
            if (
              caseEntry.notes.includes('placed this case on-hold') &&
              (caseEntry.author === 'DNIF' || caseEntry.author === Common.nativeAuthor)
            ) {
              ind = i + 1
            }

            if (i === ind) {
              notes.push({
                ...caseEntry,
                author: JSONData[i - 1].notes, // Update the author
              })
            } else {
              notes.push(caseEntry)
            }
          }
          JSONData = notes
          // this.setState({ NotesList: response.data.data[0][selected.case_id] }, () => {
          this.setState({ NotesList: JSONData }, () => {
            if (scroll) this.scrollToBottom()
          })
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        Common.showNotifications(
          'error',
          err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong',
        )
      })
  }

  getAlloverUsersList = userPageSize => {
    var param = {
      scope_id: this.state.scopeId,
      pageno: 1,
      pagesize: userPageSize ? userPageSize : 10,
    }
    SignalCasesService.getUsersList(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
        }
        if (response.data.status === 'success') {
          this.setState({ UsersList: response.data.data })
          if (param.pagesize !== response.data.count && response.data.count > param.pagesize) {
            this.getAlloverUsersList(response.data.count)
          }
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        Common.showNotifications(
          'error',
          err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong',
        )
      })
  }

  replaceURLs = message => {
    if (!message) return

    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
    return document.getElementById(message)
      ? (document.getElementById(message).innerHTML = message.replace(urlRegex, function(url) {
          var hyperlink = url
          if (!hyperlink.match('^https?://')) {
            hyperlink = 'https://' + hyperlink
          }
          return (
            '<a href="' +
            hyperlink +
            '" style="cursor: pointer; color:#00bfff;" target="_blank" rel="noopener noreferrer">' +
            url +
            '</a>'
          )
        }))
      : this.escapeHtml(message)
  }

  escapeHtml = text => {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    }

    return text.replace(/[&<>"']/g, function(m) {
      return map[m]
    })
  }

  setTagList = item => {
    var tagList = this.state.tagList
    tagList.push(item.name)
  }

  addNotes = Msg => {
    var param = {
      case_id: this.state.selectedCase.case_id,
      scope_id: this.state.scopeId,
      notes: this.escapeHtml(Msg),
      author: this.state.UserDetails.email,
      tag_list: [],
    }

    SignalCasesService.addNotetoCase(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
          Common.showNotifications('error', 'Something went wrong')
        }
        if (response.data.status === 'success') {
          this.setState({ NoteMsg: '', messageStatus: 'Saved' }, () => {
            this.inputField.rcMentions.state.value = ''
            this.getNotesList(this.state.selectedCase, true)
          })
          setTimeout(() => this.setState({ messageStatus: 'Save' }), 5000)
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        this.setState({ messageStatus: 'Retry' })
      })
  }

  replaceURLs = message => {
    if (!message) return

    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
    return document.getElementById(message)
      ? (document.getElementById(message).innerHTML = message.replace(urlRegex, function(url) {
          var hyperlink = url
          if (!hyperlink.match('^https?://')) {
            hyperlink = 'https://' + hyperlink
          }
          return (
            '<a href="' +
            hyperlink +
            '" style="cursor: pointer; color:#cc0066;" target="_blank" rel="noopener noreferrer">' +
            url +
            '</a>'
          )
        }))
      : this.escapeHtml(message)
  }

  escapeHtml = text => {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    }

    return text.replace(/[&<>"']/g, function(m) {
      return map[m]
    })
  }

  // filter cases
  searchCases = () => {
    const casesFiltered = []
    const { casesList, inputValue } = this.state
    for (var c = 0; c < casesList.length; c++) {
      if (casesList[c].case_name.toLowerCase().includes(inputValue.toLowerCase()))
        casesFiltered.push(casesList[c])
    }

    this.setState({
      filteredCasesList: casesFiltered,
      //inputValue: '',
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { NoteMsg } = this.state
    if (NoteMsg !== undefined && NoteMsg !== null) {
      this.addNotes(NoteMsg.trim())
    }
  }

  render() {
    const {
      messageStatus,
      NotesList,
      UsersList,
      selectedCase,
      filteredCasesList,
      NoteMsg,
    } = this.state
    const ContentDOM = (
      <div style={{ maxHeight: document.body.clientHeight - 85 }}>
        <Select
          style={{
            width: this.props.type === 'drawer' ? '99%' : '92%',
            marginLeft: this.props.type === 'drawer' ? '2px' : null,
          }}
          className="scroll-barStyle"
          showSearch
          // optionFilterProp="children"
          placeholder="Select Case"
          onSearch={val =>
            this.setState({ inputValue: val }, () => {
              this.searchCases()
            })
          }
          defaultValue={this.props.CaseData ? this.props.CaseData.case_name : ''}
        >
          {filteredCasesList.map(item => (
            <Option
              value={item.case_name}
              key={item.case_name}
              onClick={() => {
                this.setState(
                  {
                    NotesList: [],
                  },
                  () => this.setCaseData(item),
                )
              }}
            >
              <div
                style={{
                  cursor: 'pointer',
                  display: 'inline-flex',
                  width: this.props.type === 'drawer' ? '390px' : '370px',
                  fontFamily: 'Mukta',
                }}
              >
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: this.props.type === 'drawer' ? '310px' : '290px',
                    marginTop: '0px',
                    fontWeight: 'bold',
                  }}
                >
                  <Tag className={style.Open_Tag}>
                    {/* <Tag className={item.status === 'ON-HOLD' ? style.Hold_Tag : style.Open_Tag}> */}
                    <Tooltip title={item.status}>
                      <i
                        className={
                          item.status === 'OPEN'
                            ? 'fal fa-folder-open'
                            : item.status === 'ON-HOLD'
                            ? 'fal fa-pause-circle'
                            : 'fad fa-ellipsis-h'
                        }
                      ></i>
                    </Tooltip>
                  </Tag>
                  {item.case_name}
                </div>

                <span style={{ margin: '0px 5px 0px auto' }}>
                  <Tag
                    className={style.defaultTags}
                    style={{
                      marginRight: 5,
                      fontWeight: 'bold',
                    }}
                  >
                    <span
                      className={style.TagSeverity}
                      style={{
                        backgroundColor:
                          item.severity === 'Critical'
                            ? '#D5493C'
                            : item.severity === 'High'
                            ? '#EA671B'
                            : item.severity === 'Medium'
                            ? '#F3C300'
                            : item.severity === 'Low'
                            ? '#389837'
                            : item.severity === 'None'
                            ? 'white'
                            : null,
                      }}
                    ></span>
                    {item.severity}
                  </Tag>
                </span>
              </div>
            </Option>
          ))}
        </Select>

        {this.props.type === 'non-drawer' ? (
          <span style={{ float: 'right', marginRight: '5px' }}>
            <span
              style={{
                position: 'absolute',
                right: '15px',
                cursor: 'pointer',
                fontSize: '16px',
                marginTop: '5px',
              }}
              onClick={() => {
                if (this.stopNotesList) {
                  clearInterval(this.stopNotesList)
                }
                this.setState({ selectedCase: {}, NotesList: [] }, () =>
                  this.props.setPanelVisibility(),
                )
              }}
            >
              <Tooltip title={'Close'}>
                <i className="far fa-arrow-to-right"></i>
              </Tooltip>
            </span>
          </span>
        ) : null}
        <hr style={{ background: '#222427', margin: '6px -1px 6px -7px', height: '1px' }} />

        {Object.keys(selectedCase).length > 0 ? (
          <div>
            <div
              style={{
                maxHeight:
                  this.props.type === 'non-drawer'
                    ? document.body.clientHeight - 210
                    : document.body.clientHeight - 198,
                minHeight:
                  this.props.type === 'non-drawer'
                    ? document.body.clientHeight - 210
                    : document.body.clientHeight - 198,
                background: '#rgb(46, 49, 52)',
                borderRadius: '4px',
                overflow: 'auto',
                margin: '0px 5px 0px 0px',
              }}
              className="scroll-barStyle"
            >
              <table style={{ width: '100%' }}>
                <tbody>
                  {NotesList.map((noteData, index) =>
                    noteData.author === 'DNIF' || noteData.author === Common.nativeAuthor ? (
                      <tr>
                        <td>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              margin: '8px auto',
                              padding: '0px 10px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '0.857143rem',
                                textAlign: 'center',
                                backgroundColor: '#1f2124',
                                padding: '4px 8px',
                                borderRadius: '4px',
                              }}
                            >
                              <span
                                style={{
                                  color: '#ffffffc4',
                                  margin: '0px 4px 0px 0px',
                                  fontSize: '0.857143rem',
                                }}
                              >
                                {noteData.notes !== null ? (
                                  <span>{this.replaceURLs(noteData.notes)}</span>
                                ) : (
                                  <span> </span>
                                )}
                              </span>

                              <span
                                style={{
                                  color: '#8e8e8e',
                                  marginLeft: '5px',
                                  fontSize: '0.857143rem',
                                }}
                              >
                                - {Common.getformatedTime(noteData.cnam_time, 'DateTime')}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td
                          style={{
                            padding: '2px 2px',
                            margin: '2px 0px',
                          }}
                        >
                          <div
                            style={{
                              color: '#d3d3d3',
                              display: 'inline-flex',
                              marginLeft: '8px',
                            }}
                          >
                            <span
                              style={{
                                marginRight: '5px',
                                fontSize: '0.857143rem',
                              }}
                            >
                              <i className="fal fa-user"></i>
                            </span>
                            <span style={{ fontSize: '0.857143rem' }}>{noteData.author}</span>
                            <div
                              style={{
                                fontSize: '0.857142857rem',
                                color: '#757575',
                                marginLeft: 'inherit',
                              }}
                            >
                              {Common.getformatedTime(noteData.cnam_time, 'DateTime')}
                            </div>
                          </div>

                          <div
                            style={{
                              overflowWrap: 'anywhere',
                              fontSize: '0.857143rem',
                              background: '#2E3032',
                              padding: '6px 8px',
                              margin: '4px 2px 4px 2px',
                              borderRadius: '4px',
                              userSelect: 'text',
                              fontWeight: 'bolder',
                            }}
                            id={noteData.notes}
                            ref={el => {
                              if (NotesList.indexOf(noteData) === NotesList.length - 1)
                                this.messagesEnd = el
                              else this.messagesEnd = null
                            }}
                          >
                            <span>{this.replaceURLs(noteData.notes)}</span>
                          </div>
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>

            <hr
              style={{
                background: '#222427',
                margin: '6px -1px 6px -7px',
                height: '1px',
              }}
            />
            <div style={{ display: 'flex', marginTop: '11px' }}>
              {' '}
              <Mentions
                ref={input => {
                  this.inputField = input
                }}
                className="scroll-barStyle"
                required
                placement="top"
                placeholder="Enter Notes..."
                rows={1}
                style={{ width: '83%' }}
                autoFocus={true}
                onChange={value => {
                  if (value.trim()) {
                    this.setState({ messageStatus: 'Save', NoteMsg: value })
                  } else this.setState({ NoteMsg: '' })
                }}
              >
                {UsersList.map(data => (
                  <Option value={data.name}>
                    <span
                      onClick={() => {
                        this.setTagList(data)
                      }}
                    >
                      {data.name}
                    </span>
                  </Option>
                ))}
              </Mentions>
              <Button
                type="primary"
                className={'Notes-Save'}
                style={{
                  padding: '0px 5px',
                  cursor: 'pointer',
                  margin: '0px 6px 0px',
                  height: '30px',
                  width: '64px',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                }}
                disabled={!NoteMsg.trim()}
                size={'large'}
                onClick={e => this.handleSubmit(e)}
              >
                {messageStatus === 'Saved' ? (
                  <i
                    className="fal fa-check"
                    style={{ color: '#3fc833', marginRight: '3px', fontSize: '10px' }}
                  ></i>
                ) : null}
                {messageStatus === 'Retry' ? (
                  <i
                    className="fal fa-redo"
                    style={{ color: '#161819', marginRight: '3px', fontSize: '10px' }}
                  ></i>
                ) : null}

                {messageStatus}
              </Button>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: 'center', color: '#757575' }}>
            <span>
              <i className="fal fa-file-alt"></i> NO CASE SELECTED
            </span>
          </div>
        )}
      </div>
    )

    if (this.props.type === 'drawer') {
      return (
        <Drawer
          title={
            <>
              <div className={style.DrawerTitle}>
                <span>
                  <strong>Notes</strong>
                </span>
                <span style={{ float: 'right', marginRight: '31px' }}>
                  <span
                    style={{ position: 'absolute', right: '14px', cursor: 'pointer' }}
                    onClick={() => {
                      if (this.stopNotesList) {
                        clearInterval(this.stopNotesList)
                      }
                      this.setState({ selectedCase: {}, NotesList: [] }, () => {
                        this.props.setPanelVisibility()
                      })
                    }}
                  >
                    <Tooltip title={'Close'}>
                      <i className="far fa-arrow-to-right"></i>
                    </Tooltip>
                  </span>
                </span>
              </div>
            </>
          }
          width={448}
          style={{ marginTop: '44px' }}
          placement="right"
          closable={false}
          mask={true}
          keyboard={true}
          onClose={() => {
            if (this.stopNotesList) {
              clearInterval(this.stopNotesList)
            }
            this.setState(
              {
                selectedCase: {},
                NotesList: [],
              },
              () => {
                this.props.setPanelVisibility()
              },
            )
          }}
          visible={this.props.visible}
        >
          {ContentDOM}
        </Drawer>
      )
    } else {
      if (this.props.type === 'non-drawer') {
        return (
          <Drawer
            width={448}
            style={{ marginTop: '93px' }}
            placement="right"
            closable={false}
            mask={true}
            keyboard={true}
            onClose={() => {
              if (this.stopNotesList) {
                clearInterval(this.stopNotesList)
              }
              this.setState({ selectedCase: {}, NotesList: [] }, () =>
                this.props.setPanelVisibility(),
              )
            }}
            visible={this.props.visible}
          >
            <div>{ContentDOM}</div>
          </Drawer>
        )
      }
    }
  }
}

export default withRouter(NotesComp)
